import React from 'react';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelButton from './CancelButton';
import ConfirmationButton from './ConfirmationButton';

export default function ConfirmationSection({ text, onCancel, onConfirm }) {
  return (
    <section className="delivery-zone-section-style">
      <span className="delivery-zone-confirmation-text">{text}</span>
      <div className="delivery-zone-confirmation-button-group" >
        <CancelButton label="Cancel" icon={<CancelIcon />} onClick={onCancel} />
        <ConfirmationButton label="Confirm" icon={<CheckCircleIcon />} onClick={onConfirm} />
      </div>
    </section>
  );
}
